

const context = {
	apiURL : "https://password-reset-pentcloud.vercel.app"
}

export default context;